export default "__VITE_ASSET__CQVexjMa__"